import { render } from "./BannerFootage.vue?vue&type=template&id=563ad25c"
import script from "./BannerFootage.vue?vue&type=script&lang=js"
export * from "./BannerFootage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/BannerFootage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "563ad25c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('563ad25c', __exports__)) {
    api.reload('563ad25c', __exports__)
  }
  
  module.hot.accept("./BannerFootage.vue?vue&type=template&id=563ad25c", () => {
    api.rerender('563ad25c', render)
  })

}


export default __exports__